<header class="header">
  @if (loadingService.loading()) {
  <div class="loading-bar">
    <div class="loading-bar-progress"></div>
  </div>
  }
  <div class="header-left">
    <button class="header-btn hamburger" (click)="sidebarService.toggle()" aria-label="Menu openen">
      <app-icon name="menu" size="md" />
    </button>
    <div class="header-badge">
      <span class="header-badge-text">Expertteam</span>
    </div>
  </div>
  <div class="header-right">
    <div class="search-box">
      <app-icon name="search" size="sm" />
      <input type="text" placeholder="Taxatienr. of kenteken..."
        (keydown.enter)="onSearchSubmit($event)">
    </div>
    <button class="header-btn theme-toggle" (click)="themeService.toggleTheme()" title="Wissel thema">
      <app-icon [name]="themeService.isDarkMode() ? 'moon' : 'sun'" size="md" />
    </button>
    <div class="notifications-wrapper">
      <button class="header-btn" (click)="toggleNotifications()">
        <app-icon name="bell" size="md" />
        @if (hasNotifications()) {
          <span class="notification-dot"></span>
        }
      </button>
      @if (notificationsOpen()) {
      <div class="notifications-dropdown" (clickOutside)="closeNotifications()">
        <div class="notifications-header">
          <h3>Notificaties</h3>
          @if (unreadCount() > 0) {
            <span class="notifications-badge">{{ unreadCount() }} nieuw</span>
          }
        </div>
        @if (recentNotifications().length > 0) {
          <div class="notifications-list">
            @for (notification of recentNotifications(); track notification.id) {
              <div
                class="notification-item"
                [class.unread]="!notification.read"
                (click)="notificationService.performAction(notification)"
              >
                <div class="notification-icon {{ getIconClassForType(notification.type) }}">
                  <app-icon [name]="getIconForType(notification.type)" size="sm" />
                </div>
                <div class="notification-content">
                  <div class="notification-text">
                    <strong>{{ notification.title }}</strong> {{ notification.message }}
                  </div>
                  <div class="notification-time">{{ getRelativeTime(notification.timestamp) }}</div>
                </div>
              </div>
            }
          </div>
        }
        <div class="notifications-footer">
          <a href="#" (click)="$event.preventDefault(); openNotificationCenter()">Naar notificatiecentrum</a>
        </div>
      </div>
      }
    </div>
    @if (isAuthenticated()) {
    <div class="user-menu-wrapper">
      <button class="header-btn user-menu-btn" (click)="toggleUserMenu()">
        <span class="user-initials">{{ userInitials() }}</span>
      </button>
      @if (userMenuOpen()) {
      <div class="user-menu-dropdown">
        <div class="user-menu-header">
          <div class="user-info">
            <div class="user-name">{{ userName() || 'Gebruiker' }}</div>
            <div class="user-email">{{ companyName() }}</div>
          </div>
        </div>
        <div class="user-menu-divider"></div>
        <div class="user-menu-items">
          @if (hasMultipleCompanies()) {
          <button class="user-menu-item" (click)="switchCompany()">
            <app-icon name="arrow-left-right" size="sm" />
            <span>Wissel van bedrijf</span>
          </button>
          }
          <button class="user-menu-item" (click)="navigateToSettings()">
            <app-icon name="settings" size="sm" />
            <span>Instellingen</span>
          </button>
          <button class="user-menu-item logout" (click)="logout()">
            <app-icon name="logout" size="sm" />
            <span>Uitloggen</span>
          </button>
        </div>
      </div>
      }
    </div>
    } @else {
    <button class="header-btn desktop-only">
      <app-icon name="user" size="md" />
    </button>
    }
  </div>
</header>